import {
  fetchGuideStepCreate,
  fetchGuideStepDelete,
  fetchGuideStepUpdate,
  guideQueryOptions,
  useGuideUpdateMutation,
} from '@blesk-frontend/api';
import {Page} from '@blesk-frontend/ui';
import {useQuery} from '@tanstack/react-query';
import {useEffect} from 'react';
import {toast} from 'sonner';
import {GuideForm, GuideFormData, GuideSkeleton} from '@/features/guides';
import {sendEvent} from '@/libs/analytics';
import {Route} from '@/routes/_app/guides/$guideId.edit';

export const GuideEditPage = () => {
  const navigate = Route.useNavigate();

  const {data: guide, isLoading, refetch} = useQuery(guideQueryOptions(Route.useParams().guideId));
  const {mutateAsync: guideMutateAsync} = useGuideUpdateMutation();

  const searchParams = Route.useSearch();

  /**
   * @deprecated
   * Используется для обратной совместимости с версией 0.7.1 десктопного приложения
   * В будущем будет удалено. Логика перешла на страницу просмотра
   */
  useEffect(() => {
    window.scrollTo(0, 0);

    if (searchParams.new) {
      sendEvent('guides/create');
    }
  }, [searchParams]);

  const onSubmit = async (data: GuideFormData) => {
    if (!guide) {
      toast.error('Произошла ошибка');
      return;
    }

    await guideMutateAsync({
      id: guide.id,
      name: data.name,
      description: data.description,
    });

    const toCreateSteps = data.steps.filter((step) => !guide.steps.some((s) => s.id === step.id));

    const toDeleteSteps = guide.steps.filter((step) => !data.steps.some((s) => s.id === step.id));

    const toUpdateSteps = data.steps.filter((step) => guide.steps.some((s) => s.id === step.id));

    await Promise.all([
      ...toCreateSteps.map((step) => fetchGuideStepCreate(guide.id, step)),
      ...toDeleteSteps.map((step) => fetchGuideStepDelete(guide.id, step.id)),
      ...toUpdateSteps.map((step) => fetchGuideStepUpdate(guide.id, step)),
    ]);

    await refetch();

    await navigate({
      to: '/guides/$guideId',
      params: {guideId: guide.id},
      search: {
        /**
         * @deprecated
         * Используется для обратной совместимости с версией 0.7.1 десктопного приложения
         * В будущем будет удалено. Логика перешла на страницу просмотра
         */
        ...(searchParams.new && {export: true}),
        ...(searchParams.discountId && {discountId: searchParams.discountId}),
      },
    });

    toast.success('Изменения сохранены');
    window.scrollTo(0, 0);
  };

  if (isLoading || !guide) {
    return <GuideSkeleton />;
  }

  return (
    <Page>
      <GuideForm guide={guide} onSubmit={onSubmit} />
    </Page>
  );
};
